exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/_wks-ext.js
// module id = 25
// module chunks = 0